import React, { useState, useEffect } from 'react';
import { Button, Container } from 'react-bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Link } from 'react-router-dom';

const LoginPromoSection = () => {
    const [currentText, setCurrentText] = useState(0);
    const texts = [
        "Premium Benefits",
        "Banking Rewards",
        "EMI Perks",
        "VIP Offers"
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentText((prev) => (prev + 1) % texts.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [texts.length]);

    return (
        <section className="login-promo py-5 my-lg-5">
            <Container>
                <div className="position-relative p-1 rounded-5"
                    style={{
                        background: 'linear-gradient(135deg, #2563eb, #10b981, #7c3aed)',
                        backgroundSize: '200% 200%',
                        animation: 'gradientShift 6s ease infinite',
                    }}>

                    <style>
                        {`
                        @keyframes gradientShift {
                            0% { background-position: 0% 50%; }
                            50% { background-position: 100% 50%; }
                            100% { background-position: 0% 50%; }
                        }
                        @keyframes textFade {
                            0% { opacity: 0; transform: translateY(10px); }
                            20% { opacity: 1; transform: translateY(0); }
                            80% { opacity: 1; transform: translateY(0); }
                            100% { opacity: 0; transform: translateY(-10px); }
                        }
                        .text-gradient {
                            background: linear-gradient(90deg, #2563eb, #7c3aed);
                            -webkit-background-clip: text;
                            background-clip: text;
                            color: transparent;
                        }
                        `}
                    </style>

                    <div className="rounded-5 p-4 p-md-5"
                        style={{
                            backdropFilter: 'blur(12px)',
                            backgroundColor: 'rgba(255, 255, 255, 0.95)',
                            border: '1px solid rgba(255, 255, 255, 0.8)',
                            boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)'
                        }}>
                        <div className="d-flex flex-column flex-lg-row align-items-center justify-content-between">
                            <div className="text-center text-md-start mb-4 mb-lg-0">
                                <h2 className="fw-bold mb-3 display-6">
                                    <span className="">Unlock</span> Your <br className="d-md-none" />
                                    <span
                                        key={currentText}
                                        style={{
                                            animation: 'textFade 3s ease',
                                            fontWeight: 700,
                                            background: 'linear-gradient(90deg, #0077ffff, #9a6de2ff)',
                                            WebkitBackgroundClip: 'text',
                                            backgroundClip: 'text',
                                            color: 'transparent'
                                        }}
                                    >
                                        {texts[currentText]}
                                    </span>
                                </h2>
                                <p className="text-muted fs-5 mb-0">
                                    Log in to access <strong className="text-dark">personalized EMI plans</strong> and <strong className="text-dark">instant approval</strong> with DBS.
                                </p>
                            </div>

                            <Button
                                as={Link}
                                to="/sign-in"
                                variant="outline-primary"
                                size="md"
                                className="rounded-pill fw-bold px-4 py-2 position-relative overflow-hidden border-2"
                            >
                                <span className="position-relative z-2">
                                    <i className="bi bi-lightning-charge-fill me-2"></i>
                                    Signup for free
                                </span>
                                <span className="position-absolute top-0 start-0 h-100 bg-primary"
                                    style={{
                                        width: '0%',
                                        transition: 'width 0.4s ease',
                                        zIndex: 1
                                    }}
                                ></span>
                                <style>
                                    {`
                                        .btn-outline-primary:hover .bg-primary {
                                            width: 100% !important;
                                        }
                                        .btn-outline-primary:hover {
                                            color: white !important;
                                        }
                                    `}
                                </style>
                            </Button>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default LoginPromoSection;